const basePalette = {
  primary: {
    // main: "#ff9200", - To reverse to light theme uncomment and comment main used theme
    main: "#FF7A00", //"#e6007e",
    second: "#FF4B4B",
    light: "#FF9B40",
    contrastText: "#fff",
    active: "#FF7A00",
    border: "#212326",
    text: "#B8B9BC"
  },
  secondary: {
    main: "#0E0F10", //"#444355",
    light: "#0063af",
    lighter: "#686775",
    dark: "#03205a",
    text: "#FEFEFE",
    contrastText: "#fff"
  },
  error: {
    main: "#FF4B4B",
    light: "#FF4B4B",
    dark: "#FF4B4B",
    contrastText: "#fff"
  },
  grey: {
    main: "#a9afbf",
    light: "rgba(213, 215, 222, .72)",
    lighter: "#f4f4f7",
    dark: "#9298a8",
    contrastText: "#ebebef",
    border: "#212326",
    text: "#B8B9BC"
  }
};

export default basePalette;
